import React, { useContext, useEffect, useState } from 'react';
import { CircularProgress, makeStyles, TextField } from '@material-ui/core';
import DialogAcerBrag from '../../components/UI/DialogAcerBrag';
import LimitedBackdrop from '../../components/UI/LimitedBackdrop';
import { AppContext } from '../../contexts/AppContext';
import { separations } from '../../constants/StyleConstants';
import { Fragment } from 'react';
import LogisticsAPI from '../../services/LogisticsAPI';

const useStyles = makeStyles(theme => ({
  ...separations,
  dialogContainer: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '40em',
  },
  contiguous: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridGap: '1em',
  },
}));

const LogisticsCommentsModal = ({ open, setOpen, commentParams: { cuit, reference, hasComments }, updateGrid }) => {
  const classes = useStyles();
  const { showError, showSuccess } = useContext(AppContext);
  const [comment, setComment] = useState('');
  const [openBackDrop, setOpenBackDrop] = useState(false);

  const resetFields = () => {
    setComment('');
  };

  useEffect(() => {
    if (open && hasComments) {
      setOpenBackDrop(true);

      const request = {
        Cuit: cuit,
        Reference: reference,
      };

      LogisticsAPI.getComment(request)
        .then(res => {
          setComment(res);
          setOpenBackDrop(false);
        })
        .catch(error => {
          finish();
          showError('No se pudieron cargar los comentarios para el registro solicitado');
        });
    } else {
      setTimeout(() => {
        resetFields();
      }, 500);
    }
  }, [open, cuit]);

  const finish = () => {
    setOpen(false);
    setTimeout(() => {
      resetFields();
      setOpenBackDrop(false);
    }, 500);
  };

  const saveComment = () => {
    setOpenBackDrop(true);

    const request = {
      Cuit: cuit,
      Reference: reference,
      Comment: comment,
    };

    LogisticsAPI.setComment(request)
      .then(result => {
        updateGrid(reference, !comment.isBlank());
        finish();
        showSuccess('Comentario guardado con éxito');
      })
      .catch(error => {
        finish();
        showError('No se pudo guardar el comentario');
      });
  };

  return (
    <Fragment>
      <DialogAcerBrag open={open} setOpen={setOpen} title={`Comentarios para Nro. de Remito ${reference}`} action={saveComment}>
        <LimitedBackdrop open={openBackDrop}>
          <CircularProgress color="primary" />
        </LimitedBackdrop>
        <div className={classes.dialogContainer}>
          <TextField
            fullWidth
            margin="dense"
            multiline
            rowsMax={20}
            id="comment"
            label="Comentario"
            onChange={e => setComment(e.target.value)}
            value={comment}
          />
        </div>
      </DialogAcerBrag>
    </Fragment>
  );
};
export default LogisticsCommentsModal;
